import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as r } from "react";
const s = ({
  title: l,
  titleId: c,
  ...o
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": c,
    ...o,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: c, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M267.294 286.118c0-10.396 8.429-18.825 18.825-18.825h169.41c20.794 0 37.647-16.855 37.647-37.647s-16.853-37.647-37.647-37.647h-169.41c-51.981 0-94.118 42.138-94.118 94.118V737.88c0 51.981 42.138 94.118 94.118 94.118h451.763c51.981 0 94.118-42.138 94.118-94.118V568.47c0-20.794-16.855-37.647-37.647-37.647s-37.647 16.853-37.647 37.647v169.41c0 10.396-8.429 18.825-18.825 18.825H286.118c-10.396 0-18.825-8.429-18.825-18.825V286.117zm320-56.471c0-20.792 16.855-37.647 37.647-37.647h150.588C806.718 192 832 217.282 832 248.471v150.588c0 20.791-16.855 37.647-37.647 37.647s-37.647-16.855-37.647-37.647v-78.524L548.032 529.209c-14.701 14.701-38.539 14.701-53.242 0-14.701-14.703-14.701-38.541 0-53.242l208.674-208.674H624.94c-20.791 0-37.647-16.855-37.647-37.647z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m = r(s);
export {
  m as default
};
